export enum SpecifierObservationType {
  'AttendanceNotNeeded' = 0,  
  'FollowUpOffline' = 1,
  'RemoteInspection' = 2
}
